import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import useTheme from '../../hooks/useTheme';
import { FiMenu, FiLogOut, FiUser, FiSettings, FiSun, FiMoon, FiMonitor } from 'react-icons/fi';
import { TIMEZONES } from '../../utils/constants';
import { getUserTimezone, setUserTimezone } from '../../utils/formatters';
import JornadaBotao from '../jornada/JornadaBotao';
import './Header.css';

export default function Header({ onToggleSidebar }) {
  const { usuario, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const [configOpen, setConfigOpen] = useState(false);
  const [timezone, setTimezone] = useState(getUserTimezone);

  const themeIcon = theme === 'dark' ? <FiMoon size={18} /> : theme === 'light' ? <FiSun size={18} /> : <FiMonitor size={18} />;
  const themeTitle = theme === 'dark' ? 'Tema: Escuro (clique para Auto)' : theme === 'light' ? 'Tema: Claro (clique para Escuro)' : 'Tema: Automático (clique para Claro)';
  const configRef = useRef(null);

  const handleLogout = async () => {
    if (window.confirm('Deseja sair do sistema?')) {
      await logout();
    }
  };

  const handleTimezoneChange = (e) => {
    const tz = e.target.value;
    setTimezone(tz);
    setUserTimezone(tz);
    window.dispatchEvent(new Event('timezone-change'));
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (configRef.current && !configRef.current.contains(e.target)) {
        setConfigOpen(false);
      }
    };
    if (configOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [configOpen]);

  return (
    <header className="header">
      <div className="header-left">
        <button className="btn-icon" onClick={onToggleSidebar} title="Menu">
          <FiMenu size={20} />
        </button>
        {usuario?.central?.logo_url && (
          <img
            src={usuario.central.logo_url}
            alt={usuario.central.nome || ''}
            style={{ height: 28, maxWidth: 120, objectFit: 'contain' }}
            onError={(e) => { e.currentTarget.style.display = 'none'; }}
          />
        )}
        {usuario?.central?.nome && (
          <span className="header-central-name">{usuario.central.nome}</span>
        )}
      </div>
      <div className="header-right">
        {/* Jornada primeiro: é o controle que se procura com pressa no fim do
            turno, e o canto direito é o único ponto visível de qualquer tela. */}
        <JornadaBotao />
        <div className="header-user">
          <FiUser size={16} />
          <span className="header-user-name">{usuario?.nome}</span>
          <span className="header-user-role">{usuario?.nivel}</span>
        </div>
        <button
          className="btn-icon"
          onClick={toggleTheme}
          title={themeTitle}
          style={{ position: 'relative' }}
        >
          {themeIcon}
        </button>
        <div className="config-wrapper" ref={configRef}>
          <button
            className={`btn-icon btn-config ${configOpen ? 'active' : ''}`}
            onClick={() => setConfigOpen((o) => !o)}
            title="Configuracoes"
          >
            <FiSettings size={18} />
          </button>
          {configOpen && (
            <div className="config-dropdown">
              <div className="config-dropdown-title">Configurações</div>
              <div className="config-dropdown-field">
                <label className="config-dropdown-label">Fuso Horario</label>
                <select
                  className="config-dropdown-select"
                  value={timezone}
                  onChange={handleTimezoneChange}
                >
                  {TIMEZONES.map((tz) => (
                    <option key={tz.value} value={tz.value}>{tz.label}</option>
                  ))}
                </select>
              </div>
            </div>
          )}
        </div>
        <button className="btn-icon btn-logout" onClick={handleLogout} title="Sair">
          <FiLogOut size={18} />
        </button>
      </div>
    </header>
  );
}
